import * as React from 'react';
import { FormLabel } from 'react-bootstrap';
import classNames from 'classnames';

import classes from './label.module.scss';

type LabelProps = React.ComponentProps<FormLabel>;

export const Label: React.FC<LabelProps> = ({
  children,
  className,
  ...props
}) => {
  if (!children) {
    return null;
  }

  return (
    <FormLabel className={classNames(classes.label, className)} {...props}>
      {children}
    </FormLabel>
  );
};
